import { Pipe, PipeTransform } from '@angular/core';
import { Launcher } from '../models/entities/launcher.type';

@Pipe({
  name: 'launcherSort'
})
export class LauncherSortPipe implements PipeTransform {
  transform(launchers: Launcher[]): Launcher[] {
    if (!launchers) {
      return [];
    }
    return launchers.sort((launcherA, launherB) => launcherA.Position - launherB.Position);
  }
}
